import { Directive, ElementRef, effect, inject, input } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[abxAriaPressed]',
})
export class AriaPressedDirective {
  readonly abxAriaPressed = input<boolean>(false);

  private readonly el = inject(ElementRef<HTMLElement>);

  constructor() {
    effect(() => {
      this.el.nativeElement.setAttribute('aria-pressed', String(this.abxAriaPressed()));
    });
  }
}
